import React from 'react'
import { SingleValue } from 'react-select'
import { AppSelect } from '../../../../../../components/Select'
import { formatMskDateTime } from '../../Dashboard/core/mskTime'
import { STEP_OPTIONS } from '../core/consts'

type StepOption = typeof STEP_OPTIONS[number]

type Props = {
  fromMs: number
  toMs: number
  stepMs: number
  onStep: (stepMs: number) => void
  onShift: (dir: -1 | 1) => void
  canShiftRight: boolean
  loading: boolean
}

/** Полоса навигации по окну — между фильтрами и графиком, ближе к тому, что она двигает. */
const TimelineWindowNav: React.FC<Props> = ({
  fromMs,
  toMs,
  stepMs,
  onStep,
  onShift,
  canShiftRight,
  loading,
}) => (
  <div className='d-flex flex-wrap align-items-center justify-content-between gap-3 mb-3'>
    <div className='d-flex align-items-center gap-2'>
      <button
        type='button'
        className='btn btn-sm btn-light'
        onClick={() => onShift(-1)}
        disabled={loading}
        aria-label='Окно раньше'
      >
        ◀
      </button>
      <span className='fs-6 fw-semibold text-nowrap d-inline-flex align-items-center gap-2'>
        {loading && (
          <span className='spinner-border spinner-border-sm text-primary' role='status' />
        )}
        {formatMskDateTime(new Date(fromMs).toISOString())} —{' '}
        {formatMskDateTime(new Date(toMs).toISOString())}
        <span className='text-muted fs-8 fw-normal'>МСК</span>
      </span>
      <button
        type='button'
        className='btn btn-sm btn-light'
        onClick={() => onShift(1)}
        disabled={loading || !canShiftRight}
        aria-label='Окно позже'
      >
        ▶
      </button>
    </div>
    <div className='d-flex align-items-center gap-2'>
      <span className='text-muted fs-8 fw-semibold'>Шаг сдвига</span>
      <div style={{ minWidth: 110 }}>
        <AppSelect<StepOption, false>
          options={STEP_OPTIONS}
          value={STEP_OPTIONS.find((o) => o.value === stepMs)}
          onChange={(opt: SingleValue<StepOption>) => opt && onStep(opt.value)}
          isSearchable={false}
        />
      </div>
    </div>
  </div>
)

export default TimelineWindowNav
